// src/components/trades/components/PlayerFilterBar.js
import React from 'react';
import { Search } from 'lucide-react';
import { dynastyTheme } from '../../../services/colorService';

/**
 * PlayerFilterBar Component
 * Provides position filtering and search functionality for trade roster views
 * 
 * Features:
 * - Main tabs: Batters | Pitchers (default: Batters)
 * - Search input with icon
 */
const PlayerFilterBar = ({ 
  onPositionChange, 
  onSearchChange, 
  selectedPosition = 'hitting',
  searchTerm = ''
}) => {
  const mainTabs = [
    { id: 'hitting', label: 'Batters' },
    { id: 'pitching', label: 'Pitchers' },
  ];

  return (
    <div className="space-y-3 mb-4">
      {/* Main Position Tabs */}
      <div className="flex gap-2">
        {mainTabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => onPositionChange(tab.id)}
            className={`
              px-4 py-2 rounded-lg font-medium transition-all
              ${selectedPosition === tab.id
                ? `${dynastyTheme.classes.bg.primary} ${dynastyTheme.classes.text.dark}`
                : `${dynastyTheme.classes.bg.neutralDarker} ${dynastyTheme.classes.text.neutralLight} hover:${dynastyTheme.classes.bg.neutral}`
              }
            `}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Search Input */}
      <div className="relative">
        <Search className={`absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 ${dynastyTheme.classes.text.neutralLight}`} />
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search players..."
          className={`
            w-full pl-10 pr-4 py-2 rounded-lg
            ${dynastyTheme.classes.bg.neutral}
            ${dynastyTheme.classes.text.white}
            border ${dynastyTheme.classes.border.neutral}
            focus:outline-none focus:ring-2 focus:ring-teal-500
          `}
        />
      </div>
    </div>
  );
};

export default PlayerFilterBar;
